import React, { useState } from 'react';
import { getTileGridButtons } from 'helpers/GridHelper';
import PropTypes from 'prop-types';

const Shelf = ({
  headlineText,
  items: filteredList,
  theme,
  seeMoreText,
  renderItems,
  processor,
  itemNumberLimit,
}) => {
  const [state, setState] = useState(false);
  const toggle = () => (state ? setState(false) : setState(true));
  const numberOfItemsInitiallyToShow =
    itemNumberLimit === 0 ? filteredList.length : itemNumberLimit;
  const items = state ? filteredList : filteredList.slice(0, numberOfItemsInitiallyToShow);
  return (
    <div key={headlineText}>
      <h1 className={theme.searchResultTitle}>{headlineText}</h1>
      {renderItems({ items, tileIndexOffset: 0, processor })}
      {itemNumberLimit !== 0 && filteredList.length > itemNumberLimit
        ? getTileGridButtons({
            theme,
            expanded: state,
            toggleFunction: toggle,
            toggleMoreTextOverride: seeMoreText,
          })
        : null}
      <hr className={theme.hr} />
    </div>
  );
};

export default Shelf;

Shelf.defaultProps = {
  itemNumberLimit: 4,
};

Shelf.propTypes = {
  headlineText: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  processor: PropTypes.func.isRequired,
  renderItems: PropTypes.func.isRequired,
  seeMoreText: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
  itemNumberLimit: PropTypes.number,
};
